// extracted by mini-css-extract-plugin
module.exports = {"host":"PageNotFound_host__adER5","error404":"PageNotFound_error404__3Co25","icon":"PageNotFound_icon__2ixFZ","button":"PageNotFound_button__1H8hO"};